'use strict';

const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
const globalConfig = require('../config/config');
const productRules = require('../utils/product.rules');
const buttonConstants = require('../utils/button.constants');
const trackingHandler = require('../utils/tracking.handler');
const trackingPageFlowUtils = require('od-modules/utils/flow_tracking/tracking.page.flow.utils');
const trackingUtils = require('od-modules/utils/tracking.utils');
const ShoppingCart = require('od-modules/cart/cart');
const {revampTrackingLabel} = require('od-modules/utils/membership_tracking.utils').default;
const {getStore} = require('od-modules/secure_store/store');
const {getResultFullFareSelected, isPrimeAccount} = require('od-modules/utils/membership_utils');
const {hasRememberMeCookie} = require('od-modules/utils/sso.utils');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();

const isUserLogged = () => hasRememberMeCookie();
const checkPaymentFormIsValidAndAgreedEvent = 'payment-button:checkPaymentFormIsValidAndAgreed';
const isMobile = () => Odigeo.SessionScope.flow === 'mobile';
const mustShowButtonLoading = (button, triggeredButton, shouldShow) => shouldShow && triggeredButton === button;
const isPWGButton = (button) => button === buttonConstants.PAY_WITH_GUARANTEE;
const isSingleButton = (button) => button === buttonConstants.SINGLE;
const policyIdForDualButton = (button, productId) =>
    isPWGButton(button) ? productId : globalConfig.tracking.labelForRejectedButton;
const onTermsAndConditionsClick = () => trackingHandler.getHandler().termsAndConditionsOpen(CONS.NONE_POLICY);
const isPrimeExtraDiscountEnabled = () => Odigeo.Membership.isPrimeExtraDiscountEnabled;
const isPrimeMarket = () => Odigeo.AB.isPrimeEnabled;
const isDynpack = Odigeo.Utils.isRequestApp('dp');

const CONS = {
    NONE_POLICY: 'none',
    OFFER_TYPES: {
        FULL_FARE: 'no-prime',
        PRIME_FARE: 'prime',
    },
    TRACKING: {
        CATEGORY: 'flights_pay_page',
        ACTIONS: {
            PRIME: 'prime',
            FREETRIAL_LIMITATION: 'freetrial_limitation',
        },
    },
    PAGE: 'pay',
    FREETRIAL: {
        FREETRIAL: 'freetrial',
        EXPIRED: 'expired',
    },
};

module.exports = {
    checkDoCheckout: false,
    continuing: false,
    previousTemplateSource: '',

    selectors: {
        paymentContinueButton: '.payment_continue_button',
        paymentGenericButton: '.payment_continue_button',
        paymentTermsAndConditions: '.od-paymentmanager-terms-link',
        payWithGuaranteeButton: '.pay_with_guarantee_button',
        payWithGuaranteeNormalButton: '.pay_with_guarantee_normal_button',
        payWithGuaranteeInfoMessage: '.pay_refundable_fare_info_message_click',
        payWithGuaranteeInfoMessageBox: '.pay_refundable_fare_info_message_box',
        payWithGuaranteeInfoMessageClose: '.pay_refundable_fare_info_message_close',
        payWithGuaranteeContainer: '.pay_with_guarantee_container',
        payWithGuaranteeContainerPDFLink: '.pay_refundable_fare_conditions_pdf_link',
        payWithGuaranteeTermsAndConditions: '.od-paymentmanager-terms-link-refundable-fare',
        universalTermsAndConditions: '.open_agree_conditions',
    },

    selectorsBinding: {
        SINGLE: (selectors) => selectors.paymentContinueButton,
        PAY_WITH_GUARANTEE: (selectors) => selectors.payWithGuaranteeButton,
        PAY_WITH_GUARANTEE_NORMAL: (selectors) => selectors.payWithGuaranteeNormalButton,
    },

    flowTrackingBinding: {
        SINGLE: () => 'pay:normal',
        PAY_WITH_GUARANTEE_NORMAL: () => 'pay:normaldouble',
        PAY_WITH_GUARANTEE: (productId) => `pay:${productId}`,
    },

    initialize() {
        this.freetrialLimitationTracked = false;
        this.load();
        ShoppingCart.subscribe(this.loadFromCart.bind(this));
        this.model.onStoreChange = this.model.onStoreChange.bind(this);
    },

    initTracking() {
        trackingHandler.load(this.model.getProductIdForPayWithGuarantee(), this.model.getPrices());
    },

    loadFromCart() {
        this.load();
    },

    load(callback = () => { }) {
        const mustHide = productRules.mustHideTotalPrice(this.model);
        const loadCallbackData = this.getLoadCallbackData();
        const render = this.render.bind(this);

        this.model.loadData((data) => {
            render(data);
            Odigeo.trigger('payment-button:hideTotalPriceContainer', mustHide);
            this.initTracking();
            callback(loadCallbackData);
        });
    },

    getLoadCallbackData() {
        return {
            mustHideTotalPrice: productRules.mustHideTotalPrice(this.model),
        };
    },

    render(data = {}) {
        const source = this.getSource(data);

        if (this.mustRender(source)) {
            this.previousTemplateSource = source;
            this.$el.html(source);
            this.bindButtons();
            this.bindTermsAndConditions();
            this.initPayWithGuarantee(data);
            this.renderPaymentMethodsDisclaimer();
            if (Odigeo.AB.isNewUniversalTermsAndConditions) {
                this.enhancePaymentPopup();
                this.bindNewUniversalTermsAndConditions();
            }
        }
    },

    enhancePaymentPopup() {
        Odigeo.UIElements.hint.enhance('payment', this.$el.find('.popUp_payment_conditions_hint'), {
            events: {
                tap: true,
            },
            googleAnalyticsOnOpen: {
                type: 'trackEvent',
                data: {
                    page: Odigeo.History.getPageNameFromFragment(),
                    action: 'payment_details',
                    label: 'link_general_terms_and_conditions_open',
                },
            },
        });
        this.$el.find('.conditions_section_title').on(Odigeo.Events.tap, Odigeo._.bind(function(e) {
            this.showConditionsSection(e);
        }, this));
    },
    showConditionsSection: function(e) {
        e.stopPropagation();
        this.$el.find('div[class^="conditions_section_content_"]').addClass('hidden', true);
        this.$el.find('.conditions_section_content_' + $(e.currentTarget).data('layer')).removeClass('hidden');
    },

    bindNewUniversalTermsAndConditions() {
        this.bindSingleButton(this.selectors.universalTermsAndConditions, Odigeo.Events.tap, this.onUniversalTermsClick);
    },

    onUniversalTermsClick(e) {
        e.stopPropagation();
        this.$el.find('.popUp_payment_conditions_hint').eq(0).trigger('toggle');
    },

    renderPaymentMethodsDisclaimer() {
        Odigeo.trigger(`${this.id}:paymentButtonRendered`);
    },

    mustRender(source) {
        return !this.continuing && this.previousTemplateSource !== source;
    },

    getSource(data) {
        return this.getTemplate()(this.getTemplateData(data));
    },

    getTemplate() {
        return this.templates[productRules.calculateTemplate(this.model)] || (() => { });
    },

    getTemplateData(data = {}) {
        return Odigeo._.extend({}, data, {
            keys: this.model.preProcessKeysByPolicyAndApplicationFlow(this.keys),
            templates: this.templates,
            priceSizeClass: this.getPricesLengthClass(),
        });
    },

    bindButtons() {
        this.bindSingleButton(this.selectors.paymentContinueButton, Odigeo.Events.tap, this.getOnPaymentButton(buttonConstants.SINGLE));
        this.bindSingleButton(this.selectors.paymentContinueButton, Odigeo.Events.mouseover, this.onPaymentButtonMouseOver);
        this.bindPayWithGuaranteeButtons();
    },

    bindTermsAndConditions() {
        this.bindSingleButton(this.selectors.payWithGuaranteeTermsAndConditions, Odigeo.Events.tap, onTermsAndConditionsClick);
        this.bindSingleButton(this.selectors.paymentTermsAndConditions, Odigeo.Events.tap, onTermsAndConditionsClick);
    },

    bindSingleButton(selector, event = Odigeo.Events.tap, handler = () => { }) {
        this.findElement(selector).off(event).on(event, handler.bind(this));
    },

    findElement(selector) {
        return this.$el.find(selector);
    },

    toggleButton(button, triggeredButton, loading) {
        this.findElement(button)
            .attr('disabled', loading || null)
            .toggleClass('loading', mustShowButtonLoading(button, this.getSelectorBinding(triggeredButton), loading));
    },

    getSelectorBinding(triggeredButton) {
        return this.selectorsBinding[triggeredButton](this.selectors);
    },

    toggleContinueButtons(triggeredButton, loading) {
        Object.entries(this.selectorsBinding).forEach(([_, handler]) => {
            this.toggleButton(handler(this.selectors), triggeredButton, loading);
        });
    },

    getCheckDoCheckout(callback = () => { }) {
        callback(this.checkDoCheckout);
        return this.checkDoCheckout;
    },

    getOnPaymentButton(triggeredButton, productId = CONS.NONE_POLICY, beforeAction = () => Promise.resolve(true)) {
        return function(event, continueCallback = null) {
            event.preventDefault();
            event.stopPropagation();
            return this.isPaymentAgreementAgreed(event)
                ? this.onContinue(event, triggeredButton, productId, beforeAction, continueCallback)
                : this.showAgreementError(event);
        }.bind(this);
    },

    getAbuseTrackingLabel() {
        if (Odigeo.Membership.isFreeTrialLimitationActive) {
            const isFreeTrialCandidate = getStore().prime?.membershipSubscriptionDetails?.freeTrialCandidate;
            return `_user:${isFreeTrialCandidate ? CONS.FREETRIAL.FREETRIAL : CONS.FREETRIAL.EXPIRED}`;
        }
        return '';
    },

    getTrackingInfo() {
        const isFullFareSelectedResults = getResultFullFareSelected();
        const fareSelectedLabel = isFullFareSelectedResults ? CONS.OFFER_TYPES.FULL_FARE : CONS.OFFER_TYPES.PRIME_FARE;
        const abuseTracking = this.getAbuseTrackingLabel();
        return `${fareSelectedLabel}${isUserLogged() ? '-log' : ''}${abuseTracking}`;
    },

    onContinue(event, triggeredButton, productId, beforeAction, continueCallback) {
        trackClickEvent(event);
        const isDynpack = Odigeo.Utils.isRequestApp('dp');
        const productName = this.model.get('productName') ? this.model.get('productName') : Odigeo.Session.get('productName');
        const label = isDynpack ? `purchase_clicks_dynpack-${productName}` : `purchase_clicks_${productName}`;

        Odigeo.trigger(checkPaymentFormIsValidAndAgreedEvent, (promise) => promise.then((isValid) => {
            trackingUtils.trackEvent('confirm_purchase', isValid ? label : `${label}_FE_error`);
            if (isValid) {
                this.continuing = true;
                this.toggleContinueButtons(triggeredButton, true);
                this.sendOnContinueTracking(triggeredButton, productId);
                beforeAction().then(() => this.onContinueAfterAction(triggeredButton, productId, continueCallback));
            } else {
                this.launchSubmitError(triggeredButton, productId);
            }
        }));
    },

    launchSubmitError(triggeredButton, productId) {
        trackingHandler.launch('submitError', this.getOnContinueTrackingPolicyId(triggeredButton, productId));
    },

    paymentCallErrorTracking() {
        const flow = isDynpack ? 'dynpack' : 'flights';
        const pwgButtonLabel = isPWGButton(this.getLastPressedButton()) ? 'pwg' : 'def';
        const findProblemsCommitAncillariesMobileAbLabel = websiteConfigCollection.getAB().findProblemsCommitAncillariesMobile ? 'of2' : 'legacy';
        return trackingUtils.trackEventWithCategory(
            CONS.TRACKING.CATEGORY,
            'back_end_errors',
            `ancillary-call-error_but:${pwgButtonLabel}_sce:${findProblemsCommitAncillariesMobileAbLabel}_pag:${flow}_${CONS.PAGE}_page`,
            `${CONS.PAGE}`
        );
    },

    onContinueAfterAction(triggeredButton, productId, continueCallback) {
        ShoppingCart.commit().then(({success = false} = {}) => {
            this.updateCheckCheckout();
            this.sendBookFlightTrigger(productId, continueCallback, (goingToPayment) => {
                this.toggleContinueButtons(triggeredButton, goingToPayment);
            });

            this.updateLastPressedButton(triggeredButton);
            if (!success) {
                this.paymentCallErrorTracking();
            }
        });
    },

    updateLastPressedButton(triggeredButton) {
        this.lastPressedButton = triggeredButton;
    },

    getLastPressedButton() {
        return this.lastPressedButton || buttonConstants.SINGLE;
    },

    sendPrimeMobileTrackingOnContinue() {
        if (isPrimeMarket() && !isPrimeAccount(this.model.get('userStatus')) ) {
            revampTrackingLabel('continuePaymentButton');
        }
        if (isPrimeExtraDiscountEnabled()) {
            revampTrackingLabel('primeExtraDiscountContinuePaymentButton');
        }
    },

    sendOnContinueTracking(triggeredButton, productId) {
        this.sendPurchaseTracking(this.getOnContinueTrackingPolicyId(triggeredButton, productId));
        this.sendFlowTracking(triggeredButton, productId);
        if (isMobile()) {
            this.sendPrimeMobileTrackingOnContinue();
        }
    },

    getOnContinueTrackingPolicyId(triggeredButton, productId) {
        return isSingleButton(triggeredButton)
            ? CONS.NONE_POLICY
            : policyIdForDualButton(triggeredButton, productId);
    },

    sendFlowTracking(triggeredButton, productId) {
        trackingPageFlowUtils.launchEvent({
            flow: 'payment_flow_action',
            label: this.getFlowTrackingBinding(triggeredButton, productId),
        });
    },

    getFlowTrackingBinding(triggeredButton, productId) {
        return this.getFlowTrackingHandler(triggeredButton)(productId);
    },

    getFlowTrackingHandler(triggeredButton) {
        return this.flowTrackingBinding[triggeredButton] || (() => CONS.NONE_POLICY);
    },

    onPaymentButtonMouseOver() {
        Odigeo.trigger(globalConfig.onContinueButtonMouseOver);
    },

    sendBookFlightTrigger(productId, continueCallback, validationResolve) {
        Odigeo.trigger(globalConfig.onContinueTrigger, this.id, {
            continueCallback,
            validationResolve,
        });
    },

    updateCheckCheckout() {
        if (Odigeo.AB.isBuyerFormFunctionalityDecoupledInMobile && isMobile()) {
            this.checkDoCheckout = true;
        }
    },

    sendPurchaseTracking(productId) {
        this.getPurchaseTrackingHandler().apply(trackingHandler.getHandler(), [productId]);
    },

    getPurchaseTrackingHandler() {
        return trackingHandler.getHandler()[productRules.getContinueTracking(this.model)] || (() => { });
    },

    hasToBeImplicitlyChecked(event) {
        return this.getAgreeCheckbox(event).length > 0;
    },

    getAgreeCheckbox(event) {
        return this.findElement(`.check_${this.getTriggeredButtonId(event)}`);
    },

    getAgreeCheckboxError(event) {
        return this.findElement(`.check_error_${this.getTriggeredButtonId(event)}`);
    },

    isAgreeCheckboxAgreed(event) {
        return this.getAgreeCheckbox(event).is(':checked');
    },

    getTriggeredButtonId(event) {
        return $(event.target).closest('button').attr('id');
    },

    isPaymentAgreementAgreed(event) {
        return !this.hasToBeImplicitlyChecked(event) || this.isAgreeCheckboxAgreed(event);
    },

    showAgreementError(event) {
        this.getAgreeCheckboxError(event).removeClass('odf-hidden');
    },

    toggleButtons(disabled) {
        this.continuing = disabled;
        this.toggleContinueButtons(buttonConstants.SINGLE, disabled);
    },

    getExpectedPrice() {
        const prices = this.model.getPrices();

        return isPWGButton(this.getLastPressedButton())
            ? prices.totalWithGuarantee
            : prices.totalWithoutGuarantee;
    },
};
